// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gq-6";
export var emphasizeQuantity = "_gq-3";
export var flatBottomCorners = "_gq-5";
export var productImage = "_gq-0";
export var quantityContainer = "_gq-2";
export var tooltip = "_gq-1";
export var wrapAndEllipsesOverflow = "_gq-4";